import React from 'react';
import Action from "./Action";
import { COMMON } from '../../constants/localization';
import { ACTION_DISPLAY_TYPES } from '../../constants/enums';
import { ICON_SVG_PATH } from '../../constants/iconsvg';
import DynamicIcon from './Icons/DynamicIcon';

const BackAction = ({ onClick }: { onClick: () => void }) => (
  <Action
    title={COMMON.BACK}
    onClick={() => onClick()}
    displayType={ACTION_DISPLAY_TYPES.TEXT}
    className="-ml-16 back-chevron"
    iconLeft={<DynamicIcon path={ICON_SVG_PATH.CHEVRON_LEFT} fillColor="#05449B" strokeColor="none" size={20} />}
    size="md"
    width="narrow"
    testId="back-action"
    dataCy="back-action"
    titleClassName="btn-text-padding"
  />
);

export default BackAction;